let previousPrice = getProductPrice();
let installmentInterval;
let tmpInputValue = undefined;

function getProductPrice() {
  const withClass = document.querySelector("#product-price .product-price span");
  const spanElement = withClass || document.querySelector("#product-price span");

  if (spanElement) {
    return spanElement.textContent.replace('$', '').replace('AUD', '').replace(',', '');
  }

  return null;
}

function runProductPageLoadScript(attempt) {
   /* update afterpay instalments if variant changes the price */
  if (installmentInterval) clearInterval(installmentInterval);
  installmentInterval = setInterval(function () {
    let current_price = getProductPrice();

    if (current_price && current_price != previousPrice) {
      let instalment = current_price / 4;
      document.querySelector("#afterpay_instalments").textContent = "$" + instalment.toFixed(2) + " AUD";
      previousPrice = current_price;
    }
  }, 1000);

  // Character checker - remember to set CSS also
  let charProdCheckInput = ['#7341069926582_option_1', '#7343006056630_option_1', '#7343005630646_option_1', '#7343005204662_option_1', '#7343006875830_option_1'];
  let charProdSetSelect = ['#product-select-7341069926582-option-1', '#product-select-7343006056630-option-1', '#product-select-7343005630646-option-1', '#product-select-7343005204662-option-1', '#product-select-7343006875830-option-1'];
  let maxChars = 30;

  charProdCheckInput.forEach((item, index) => {
    var itemEl = document.getElementById(item);
    if (itemEl) {
      itemEl.addEventListener('keyup', function () {
        let inputValLength = this.value.replace(/ /g, '').length;
        if (inputValLength > maxChars) inputValLength = maxChars;
        document.getElementById(charProdSetSelect[index]).value = inputValLength;
        document.getElementById(charProdSetSelect[index]).dispatchEvent(new Event('change'));
      });
  
      itemEl.addEventListener('blur', function () {
        let inputValLength = this.value.replace(/ /g, '').length;
        if (inputValLength > maxChars) inputValLength = maxChars;
        document.getElementById(charProdSetSelect[index]).value = inputValLength;
        document.getElementById(charProdSetSelect[index]).dispatchEvent(new Event('change'));
      });
    }
  });

  // Single font previews
  document.getElementById("#product-select-519136084004-option-0")?.addEventListener("change", function () {
    let className = this.value === 'Classic font' ? 'classic' : 'script';
    document.querySelector("#product-519136084004 input[name='properties[Name / Word]']").classList.remove('classic', 'script');
    document.querySelector("#product-519136084004 input[name='properties[Name / Word]']").classList.add(className);
  });

  document.getElementById("#product-select-1188304945188-option-0")?.addEventListener("change", function () {
    let className = this.value === 'Script writing' ? 'script' : 'caps';
    document.querySelector("#product-1188304945188 input[name='properties[Wording etched on Locket]']").classList.remove('caps', 'script');
    document.querySelector("#product-1188304945188 input[name='properties[Wording etched on Locket]']").classList.add(className);
  });

  document.getElementById("#1228069797924_option_2")?.addEventListener("change", function () {
    let className = this.value === 'All capitals' ? 'caps' : 'script';
    document.querySelector("#product-1228069797924 input[name='properties[Wording etched on Pendant]']").classList.remove('caps', 'script');
    document.querySelector("#product-1228069797924 input[name='properties[Wording etched on Pendant]']").classList.add(className);
  });

  // Multiple font previews
  //var nameSelector = "#7217866080438_option_1, #7217866080438_option_2, #7196370108598_option_1, #7196370108598_option_2, #7196355788982_option_1, #7196355788982_option_2, #6737282138294_option_1, #6737282138294_option_2, #7196365324470_option_1, #7196365324470_option_2, #7216396206262_option_1, #7216396206262_option_2, #7196347105462_option_1, #7196347105462_option_2, #7196346089654_option_1, #7196346089654_option_2, #7216397779126_option_1, #7216397779126_option_2, #7216398500022_option_1, #7216398500022_option_2, #7196363096246_option_1, #7196363096246_option_2, #7196361523382_option_1, #7196361523382_option_2, #7196349956278_option_1, #7196349956278_option_2, #7216396927158_option_1, #7216396927158_option_2, #7196368994486_option_1, #7196368994486_option_2, #6737279910070_option_1, #6737279910070_option_2, #7072360792246_option_1, #6184307261622_option_1, #6184305983670_option_1, #4579735863332_option_1, #1579558567972_option_1, #1416386281508_option_1, #1424395272228_option_1, #1424404054052_option_1, #1424351133732_option_1, #1424387178532_option_1, #1424380887076_option_1, #6177620263094_option_1, #6572282708150_option_1, #6856355872950_option_1, #6221466468534_option_1";
  //var fontSelector = "#7217866080438_option_3, #7196370108598_option_3, #7196355788982_option_3, #6737282138294_option_3, #7196365324470_option_3, #7216396206262_option_3, #7196347105462_option_3, #7196346089654_option_3, #7216397779126_option_3, #7216398500022_option_3, #7196363096246_option_3, #7196361523382_option_3, #7196349956278_option_3, #7216396927158_option_3, #7196368994486_option_3, #6737279910070_option_3, #7072360792246_option_2, #6184307261622_option_1, #6184305983670_option_1, #4579735863332_option_2, #1579558567972_option_2, #1416386281508_option_2, #1424395272228_option_2, #1424404054052_option_2, #1424351133732_option_2, #1424387178532_option_2, #1424380887076_option_2, #6177620263094_option_3, #6572282708150_option_2, #6856355872950_option_3, #6221466468534_option_2";
  var nameSelector = 
  "#\\37 217866080438_option_1, #\\37 217866080438_option_2, " +
  "#\\37 196370108598_option_1, #\\37 196370108598_option_2, " +
  "#\\37 196355788982_option_1, #\\37 196355788982_option_2, " +
  "#\\36 737282138294_option_1, #\\36 737282138294_option_2, " +
  "#\\37 196365324470_option_1, #\\37 196365324470_option_2, " +
  "#\\37 216396206262_option_1, #\\37 216396206262_option_2, " +
  "#\\37 196347105462_option_1, #\\37 196347105462_option_2, " +
  "#\\37 196346089654_option_1, #\\37 196346089654_option_2, " +
  "#\\37 216397779126_option_1, #\\37 216397779126_option_2, " +
  "#\\37 216398500022_option_1, #\\37 216398500022_option_2, " +
  "#\\37 196363096246_option_1, #\\37 196363096246_option_2, " +
  "#\\37 196361523382_option_1, #\\37 196361523382_option_2, " +
  "#\\37 196349956278_option_1, #\\37 196349956278_option_2, " +
  "#\\37 216396927158_option_1, #\\37 216396927158_option_2, " +
  "#\\37 196368994486_option_1, #\\37 196368994486_option_2, " +
  "#\\36 737279910070_option_1, #\\36 737279910070_option_2, " +
  "#\\37 072360792246_option_1, #\\36 184307261622_option_1, " +
  "#\\36 184305983670_option_1, #\\34 579735863332_option_1, " +
  "#\\31 579558567972_option_1, #\\31 416386281508_option_1, " +
  "#\\31 424395272228_option_1, #\\31 424404054052_option_1, " +
  "#\\31 424351133732_option_1, #\\31 424387178532_option_1, " +
  "#\\31 424380887076_option_1, #\\36 177620263094_option_1, " +
  "#\\36 572282708150_option_1, #\\36 856355872950_option_1, " +
  
  "#\\38 359155073206_option_1, #\\38 359155073206_option_2, " +
  "#\\38 359148355766_option_1, #\\38 359148355766_option_2, " +
  "#\\38 359153041590_option_1, #\\38 359153041590_option_2, " +
  "#\\38 361215656118_option_1, #\\38 361215656118_option_2, " +
  "#\\38 361215754422_option_1, #\\38 361215754422_option_2, " +

  "#\\36 221466468534_option_1";

  // 416386281508_option_2
  var fontSelector = 
  "#\\37 217866080438_option_3, #\\37 196370108598_option_3, " +
  "#\\37 196355788982_option_3, #\\36 737282138294_option_3, " +
  "#\\37 196365324470_option_3, #\\37 216396206262_option_3, " +
  "#\\37 196347105462_option_3, #\\37 196346089654_option_3, " +
  "#\\37 216397779126_option_3, #\\37 216398500022_option_3, " +

  "#\\38 359155073206_option_3, #\\37 216398500022_option_3, " +
  "#\\38 359148355766_option_3, #\\37 216398500022_option_3, " +
  "#\\38 359153041590_option_3, #\\37 216398500022_option_3, " +
  "#\\38 361215656118_option_3, #\\37 216398500022_option_3, " +
  "#\\38 361215754422_option_3, #\\37 216398500022_option_3, " +

  "#\\37 196363096246_option_3, #\\37 196361523382_option_3, " +
  "#\\37 196349956278_option_3, #\\37 216396927158_option_3, " +
  "#\\37 196368994486_option_3, #\\36 737279910070_option_3, " +
  "#\\37 072360792246_option_2, #\\36 184307261622_option_1, " +
  "#\\36 184305983670_option_1, #\\34 579735863332_option_2, " +
  "#\\31 579558567972_option_2, #\\31 416386281508_option_2, " +
  "#\\31 424395272228_option_2, #\\31 424404054052_option_2, " +
  "#\\31 424351133732_option_2, #\\31 424387178532_option_2, " +
  "#\\31 424380887076_option_2, #\\36 177620263094_option_3, " +
  "#\\36 572282708150_option_2, #\\36 856355872950_option_3, " +
  
  "#\\36 572282708150_option_2, #\\36 856355872950_option_3, " +
  "#\\36 572282708150_option_2, #\\36 856355872950_option_3, " +
  "#\\36 572282708150_option_2, #\\36 856355872950_option_3, " +

  "#\\36 221466468534_option_2";

  
  nameSelector = nameSelector + 
    ", input[form=product_form_7217866080438]" + 
", input[form=product_form_7196370108598]" + 
", input[form=product_form_7196355788982]" + 
", input[form=product_form_6737282138294]" + 
", input[form=product_form_7196365324470]" + 
", input[form=product_form_7216396206262]" + 
", input[form=product_form_7196347105462]" + 
", input[form=product_form_7196346089654]" + 
", input[form=product_form_7216397779126]" + 

", input[form=product_form_8359155073206]" + 
", input[form=product_form_8359148355766]" + 
", input[form=product_form_8359153041590]" + 
", input[form=product_form_8361215656118]" + 
", input[form=product_form_8361215754422]" + 
", input[form=product_form_8361170632886]" + 

", input[form=product_form_7216398500022]" + 
", input[form=product_form_7196363096246]" + 
", input[form=product_form_7196361523382]" + 
", input[form=product_form_7196349956278]" + 
", input[form=product_form_7216396927158]" + 
", input[form=product_form_7196368994486]" + 
", input[form=product_form_6737279910070]" + 
", input[form=product_form_7072360792246]" + 
", input[form=product_form_6184307261622]" + 
", input[form=product_form_6184305983670]" + 
", input[form=product_form_4579735863332]" + 
", input[form=product_form_1579558567972]" + 
", input[form=product_form_1416386281508]" + 
", input[form=product_form_1424395272228]" + 
", input[form=product_form_1424404054052]" + 
", input[form=product_form_1424351133732]" + 
", input[form=product_form_1424387178532]" + 
", input[form=product_form_1424380887076]" + 
", input[form=product_form_6177620263094]" + 
", input[form=product_form_8361170632886]" + 
", input[form=product_form_6572282708150]" + 
", input[form=product_form_6856355872950]" + 
", input[form=product_form_8118882828470]" + 
", input[form=product_form_6221466468534]";

  
  fontSelector = fontSelector + 
    ", select[form=product_form_7217866080438]" + 
", select[form=product_form_7196370108598]" + 
", select[form=product_form_7196355788982]" + 
", select[form=product_form_6737282138294]" + 
", select[form=product_form_7196365324470]" + 
", select[form=product_form_7216396206262]" + 
", select[form=product_form_7196347105462]" + 
', select[form=product_form_7196346089654]:not(select[name="properties[Colour]"])' + 
', select[form=product_form_7216397779126]:not(select[name="properties[Colour]"])' + 

', select[form=product_form_8359155073206]:not(select[name="properties[Colour]"])' + 
', select[form=product_form_8359148355766]:not(select[name="properties[Colour]"])' + 
', select[form=product_form_8359153041590]:not(select[name="properties[Colour]"])' + 
', select[form=product_form_8361215656118]:not(select[name="properties[Colour]"])' + 
', select[form=product_form_8361215754422]:not(select[name="properties[Colour]"])' + 

", select[form=product_form_7216398500022]" + 
", select[form=product_form_7196363096246]" + 
', select[form=product_form_7196361523382]:not(select[name="properties[Colour]"])' + 
", select[form=product_form_7196349956278]" + 
", select[form=product_form_7216396927158]" + 
", select[form=product_form_7196368994486]" + 
", select[form=product_form_6737279910070]" + 
", select[form=product_form_7072360792246]" + 
", select[form=product_form_6184307261622]" + 
", select[form=product_form_6184305983670]" + 
", select[form=product_form_4579735863332]" + 
", select[form=product_form_1579558567972]" + 
", select[form=product_form_1416386281508]" + 
", select[form=product_form_1424395272228]" + 
", select[form=product_form_1424404054052]" + 
", select[form=product_form_1424351133732]" + 
", select[form=product_form_1424387178532]" + 
", select[form=product_form_1424380887076]" + 
", select[form=product_form_6177620263094]" + 
", select[form=product_form_8361170632886]" + 
", select[form=product_form_6572282708150]" + 
", select[form=product_form_6856355872950]" + 
", select[form=product_form_8118882828470]" + 
", select[form=product_form_6221466468534]";


  document.querySelectorAll(nameSelector).forEach((element) => {
    if (element && attempt === 1) {      
      element.addEventListener("change", function () {
        tmpInputValue = element.value;
      });
    }
  })
  
  document.querySelectorAll(fontSelector).forEach((element) => {
    element.addEventListener("change", function () {
      let className = this.value;
      let thisId = this.getAttribute("form") ?? this.id;
      let fontSize = '60px';

     //console.info('thisId', thisId)
     const upperClassName = className.toUpperCase();
      if (upperClassName === 'FREEHAND FONT') {
        className = 'font-freehand';
      } else if (upperClassName === 'CLASSIC FONT') {
          className = 'font-classic';
      } else if (upperClassName === 'FELT TIP FONT') {
          className = 'font-felt';
      } else if (upperClassName === 'PRIMARY SCHOOL FONT') {
          className = 'font-primaryschool';
      } else if (upperClassName === 'ALL CAPITALS FONT') {
          className = 'font-capitals';
      } else if (upperClassName === 'CLASSROOM FONT') {
          className = 'font-classroom';
      } else if (upperClassName === 'TEXTA CAPS FONT') {
          className = 'font-textacaps';
      } else if (upperClassName === 'CURSIVE FONT') {
          className = 'font-cursive';
      } else if (className === 'Merry Christmas (black ink)') {
          className = 'font-poppitandfinchsans';
      } else if (className === 'Colourful Christmas Trees') {
          className = 'font-buffaloregular';
      } else if (className === 'Botanical (with bird)') {
          className = 'font-silversouthscript';
      } else {
          // Check based on theId
          if (thisId === 'product_form_6184307261622' || thisId === 'product_form_6184305983670' || thisId === '6184307261622_option_1' || thisId === '6184305983670_option_1') {
              // Handle thisId specific case
          } else if (thisId === 'product_form_7072360792246' || thisId === '7072360792246_option_2') {
              className = 'font-buffaloregular';
          } else {
              // Handle option-based ids and decide the font
              let fontFreehandIds = "1579558567972_option_2|4579735863332_option_2|6184307261622_option_2|6184305983670_option_2|6177620263094_option_1|6177620263094_option_3|8361170632886_option_1|8361170632886_option_3|6572282708150_option_2|6856355872950_option_3|6221466468534_option_2|7217866080438_option_3|7196370108598_option_3|7196355788982_option_3|6737282138294_option_3|7196365324470_option_3|7216396206262_option_3|7196347105462_option_3|7196346089654_option_3|7216397779126_option_3|7216398500022_option_3|7196363096246_option_3|7196361523382_option_3|7196349956278_option_3|7216396927158_option_3|7196368994486_option_3|6737279910070_option_3";
              fontFreehandIds = fontFreehandIds + "|product_form_1579558567972|product_form_4579735863332|product_form_6184307261622|product_form_6184305983670|product_form_6177620263094|product_form_8361170632886|product_form_6572282708150|product_form_6856355872950|product_form_6221466468534|product_form_7217866080438|product_form_7196370108598|product_form_7196355788982|product_form_6737282138294|product_form_7196365324470|product_form_7216396206262|product_form_7196347105462|product_form_7196346089654|product_form_7216397779126|product_form_7216398500022|product_form_7196363096246|product_form_7196361523382|product_form_7196349956278|product_form_7216396927158|product_form_7196368994486|product_form_6737279910070";
              className = fontFreehandIds.indexOf(thisId) > -1 
                  ? 'font-freehand' 
                  : 'font-script';
          }
      }

      if (className === 'font-freehand') {        
        fontSize = '90px';
      }
      document.querySelectorAll(nameSelector).forEach(el => {
        el.classList.remove(
          ...'font-mixpalmer font-silversouthscript font-buffaloregular font-poppitandfinchsans font-classroom font-primaryschool font-capitals font-freehand font-felt font-classic font-script font-textacaps'.split(' ')
        ); // Remove all font classes
        el.classList.add(className);
        el.style = 'height: 90px !important; padding:2px !important;' + 'font-size: ' + fontSize + ' !important;'
        if (tmpInputValue && attempt === 2) {
          el.value = tmpInputValue;
          tmpInputValue = undefined;
        }
      });
    });
  });

  document.querySelectorAll(fontSelector).forEach(el => el.dispatchEvent(new Event("change")));

  // Hide show fields based on dropdown selection
  if (document.getElementById("#product-1483635195940")) {
    setTimeout(function () {
      document.querySelector("[data-option-name=wording-to-be-etched-on-disc]").after(document.querySelector("#product-select-1483635195940-option-0").parentElement.parentElement);

      document.getElementById("#product-select-1483635195940-option-0").addEventListener("change", function () {
        let val = this.value;
        document.querySelectorAll('#product-form-1483635195940 .option-type-text').forEach(el => el.style.display = 'none');

        if (val === 'Add 1 Tag - $27.50') {
          document.querySelector("[data-option-name=tag-1-text]").style.display = 'initial';
        } else if (val === 'Add 2 Tags - $36.00') {
          document.querySelector("[data-option-name=tag-1-text]").style.display = 'initial';
          document.querySelector("[data-option-name=tag-2-text]").style.display = 'initial';
        } else if (val === 'Add 3 Tags - $44.50') {
          document.querySelector("[data-option-name=tag-1-text]").style.display = 'initial';
          document.querySelector("[data-option-name=tag-2-text]").style.display = 'initial';
          document.querySelector("[data-option-name=tag-3-text]").style.display = 'initial';
        } else if (val === 'Add 4 Tags - $53.00') {
          document.querySelector("[data-option-name=tag-1-text]").style.display = 'initial';
          document.querySelector("[data-option-name=tag-2-text]").style.display = 'initial';
          document.querySelector("[data-option-name=tag-3-text]").style.display = 'initial';
          document.querySelector("[data-option-name=tag-4-text]").style.display = 'initial';
        }
      });

      document.getElementById("#product-select-1483635195940-option-0").dispatchEvent(new Event("change"));
    }, 500);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  runProductPageLoadScript(1);

  // Interval to check for the external script and re-add listeners
  const intervalId = setInterval(() => {
      // Check if the external script has loaded and removed events
      if (window.shopstorm && window.shopstorm.apps && window.shopstorm.apps.productCustomizer) {
          console.log('External script detected: shopstorm.apps.productCustomizer');

        // Re-add the event listeners
        setTimeout(function() {
          runProductPageLoadScript(2);
        }, 5000);

        // Stop the interval after re-adding the event listeners
        clearInterval(intervalId);
      }
  }, 500);
});
